import {
  NOTIFLY_GET_URL,
  NOTIFLY_UPDATE_URL,
  NotiflyGetResponse,
  NotiflyUpdateRequest,
  NotiflyUpdateResponse,
} from "@project/shared-types";
import apiFetchPost from "./apiClient";

export const NotiflyGetAPI = async () => {
  const response = await apiFetchPost<unknown, NotiflyGetResponse>(
    NOTIFLY_GET_URL,
    {}
  );
  return response;
};

export const NotiflyUpdateAPI = async (data: NotiflyUpdateRequest) => {
  const response = await apiFetchPost<
    NotiflyUpdateRequest,
    NotiflyUpdateResponse
  >(NOTIFLY_UPDATE_URL, data);
  return response;
};
